var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimerPremio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 79,
    viewBox: "0 0 74 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6113_8573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6997 0H38.9337V52.6733C38.9337 59.5646 33.323 65.1575 26.41 65.1575C19.4969 65.1575 13.8863 59.5646 13.8863 52.6733C13.8863 45.7821 19.4969 40.1891 26.41 40.1891H31.2792V26.3267H26.41C11.8224 26.3467 0 38.1317 0 52.6733C0 67.2149 11.8224 79 26.41 79C40.9976 79 52.8199 67.2149 52.8199 52.6733V21.1133C52.8199 21.1133 58.9515 28.3641 71.1947 29.7823L74 16.4592C74 16.4592 60.9954 16.7987 52.6997 0Z",
    fill: "#FFBA0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6113_8573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 79,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimerPremio);
export default __webpack_public_path__ + "static/media/primer-premio.6264a43b0ada05bc8da912f5c82e547f.svg";
export { ForwardRef as ReactComponent };